import { render, staticRenderFns } from "./PremiumInvestment.vue?vue&type=template&id=70262001"
import script from "./PremiumInvestment.vue?vue&type=script&lang=js"
export * from "./PremiumInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports